import { Method } from "axios";
import { ActionKeyPair, IService } from "@/shared/hooks/useCustomQuery";
import api from "@/shared/api/api";
import { GetPacksParams, IPack, CreatePackParams } from "./types";
import { PaginatedResponse } from "@/features/profiles/services/profiles/types";

export default class PackService implements IService {
  [key: string]: ActionKeyPair<unknown, unknown>;

  getPacks: ActionKeyPair<GetPacksParams, PaginatedResponse<IPack>> = {
    key: "get-packs",
    actionBuilder: (params) => async () => {
      const response = await api({
        url: "/v1/packs",
        method: "GET" as Method,
        params,
      });

      return response;
    },
  };

  createPack: ActionKeyPair<CreatePackParams, IPack> = {
    key: "create-pack",
    actionBuilder:
      ({ id, data }) =>
        async () => {
          const response = await api({
            url: `/v1/packs?id=${id}`,
            method: "POST" as Method,
            data,
          });

          return response;
        },
  };

  deletePack: ActionKeyPair<{ id: string }, void> = {
    key: "delete-pack",
    actionBuilder: ({ id }) => async () => {
      const response = await api({
        url: `/v1/packs/${id}`,
        method: "DELETE" as Method,
      });

      return response;
    },
  };

  //   updateUserDate: ActionKeyPair<
  //     {
  //       currentUser: IUser;
  //       expires_at?: string | null;
  //       vip_expires_at?: string | null;
  //     },
  //     void
  //   > = {
  //     key: "update-user-date",
  //     actionBuilder:
  //       ({ currentUser, expires_at, vip_expires_at }) =>
  //       async () => {
  //         if (expires_at)
  //           currentUser.subscription = {
  //             active: Boolean(currentUser.subscription?.active),
  //             expiresAt: expires_at,
  //           };

  //         if (vip_expires_at) currentUser["vipExpiresAt"] = vip_expires_at;

  //         return await api({
  //           url: "/v1/profiles",
  //           method: "POST" as Method,
  //           data: currentUser,
  //         });
  //       },
  //   };

  //   updateUser: ActionKeyPair<IUser, void> = {
  //     key: "update-user-date",
  //     actionBuilder: (newUserData) => async () => {
  //       return await api({
  //         url: "/v1/profiles",
  //         method: "POST" as Method,
  //         data: newUserData,
  //       });
  //     },
  //   };

  static Instance = new PackService();
}
